import React from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";
import CheckAnimation from "./lottieAnimation";

export default function ReferidosStepConfirmacion({ handleClose }) {
  // Disable scroll on
  // togglePopupScroll != "" && disableScroll.on();
  return (
    <Container>
      <div className="closeButtonContainer">
        <a onClick={handleClose}>
          <IoClose />
        </a>
      </div>
      <h3>¡Tu referido nos fue enviado con éxito!</h3>
      <p>Nos pondremos en contacto pronto con tu referido.</p>
      <CheckAnimation></CheckAnimation>
    </Container>
  );
}
